import type { WeekType } from '@functieloonhuis/shared';

interface WeekToggleProps {
  selectedWeek: WeekType;
  onWeekChange: (week: WeekType) => void;
  currentWeekType?: WeekType;
  hasWeekB: boolean;
}

export function WeekToggle({ selectedWeek, onWeekChange, currentWeekType, hasWeekB }: WeekToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-gray-200 p-1 bg-gray-50">
      <button
        onClick={() => onWeekChange('A')}
        className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
          selectedWeek === 'A'
            ? 'bg-indigo-600 text-white shadow-sm'
            : 'text-gray-600 hover:text-gray-900'
        }`}
        aria-pressed={selectedWeek === 'A'}
      >
        Week A{currentWeekType === 'A' ? ' (huidig)' : ''}
      </button>
      <button
        onClick={() => onWeekChange('B')}
        disabled={!hasWeekB}
        className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
          selectedWeek === 'B'
            ? 'bg-purple-600 text-white shadow-sm'
            : hasWeekB
              ? 'text-gray-600 hover:text-gray-900'
              : 'text-gray-300 cursor-not-allowed'
        }`}
        aria-pressed={selectedWeek === 'B'}
        aria-disabled={!hasWeekB}
      >
        Week B{currentWeekType === 'B' ? ' (huidig)' : ''}
      </button>
    </div>
  );
}
